// src/services/orderService.ts
import { getLedgerByCustomer } from "src/shared/services/servicesv2";
import api from "../../../../../../features/auth/axiosConfig";
import { API_URLS } from "../../../../../../shared/components/Url";
import { Order } from "src/shared/services/interfacev2";

export const fetchOrderById = async (orderId: string): Promise<Order> => {
  const { data } = await api.get(`${API_URLS.ORDER}/${orderId}`);
  return data.result as Order;
};

export const fetchCustomerLedger = async (customerId: string): Promise<number> => {
  const { data } = await getLedgerByCustomer(customerId);
  const ledger = data?.ledger;
  let balance = 0;
  if (Array.isArray(ledger)) {
    const first = ledger[0] || {};
    balance = first.totalOutstandingBalance ?? first.total_outstanding_balance ?? 0;
  } else {
    balance = ledger?.totalOutstandingBalance ?? ledger?.total_outstanding_balance ?? data?.total_outstanding_balance ?? data?.totalOutstandingBalance ?? 0;
  }
  return balance;
};

export const updateOrderStatusApi = async (orderId: string, status: string, paymentMethod?: string, adjustType: string = "refund"): Promise<void> => {
  if (status === "Cancelled") {
    const payload: any = {
      orderStatus: status,
    };
    if (paymentMethod !== "buy on credit") {
      payload.adjustType = adjustType;
    }
    await api.put(`/app/pos/v2/cancel_order?orderid=${orderId}`, payload);
  } else {
    await api.patch(`${API_URLS.ORDER}/${orderId}`, {
      orderStatus: status,
      statusChange: true,
    });
  }
};
